// modals.js
import * as React from "react";
import axios from "axios";
import { useStyletron } from "baseui";
import { toaster } from "baseui/toast";
import { FormControl } from "baseui/form-control";
import { Checkbox } from "baseui/checkbox";
import { Input } from "baseui/input";
import { Select } from "baseui/select";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalButton,
  SIZE,
  ROLE,
} from "baseui/modal";
import { KIND as ButtonKind } from "baseui/button";
import useOptions from "./useOptions"; // Import the custom hook

const apiUrl = process.env.REACT_APP_API_URL;

// NEW USER MODAL COMPONENT
// export const NewUserModal = ({
//   isOpen,
//   /* setIsUserModalOpen */ handleUserModalClose,
// }) => {
//   const { locationOptions, roleOptions } = useOptions();
//   const [formValue, setFormValue] = React.useState({
//     username: "",
//     password: "",
//     first_name: "",
//     last_name: "",
//     locations: [],
//     role: "",
//     status: "active",
//   });

//   React.useEffect(() => {
//     console.log("formValue in NewUserModal", formValue);
//     console.log("locationOptions", locationOptions);
//   }, [formValue]);

//   const handleCheckboxChange = (event) => {
//     const { value, checked } = event.target;

//     // Parse the value as an integer or a string, based on your id type
//     const idValue = parseInt(value, 10); // Change to `value` if IDs are strings

//     setFormValue((prevFormValue) => {
//       const updatedLocations = checked
//         ? [...prevFormValue.locations, idValue] // Add ID if checked
//         : prevFormValue.locations.filter((loc) => loc !== idValue); // Remove ID if unchecked

//       return {
//         ...prevFormValue,
//         locations: updatedLocations, // Update locations with IDs
//       };
//     });
//   };

//   const handleSubmitUser = async () => {
//     console.log("formValue (create user form)", formValue);
//     try {
//       const response = await axios.post(`${apiUrl}/api/user/create`, formValue);
//       console.log(response);
//       if (response.status === 200) {
//         alert("User created successfully");

//         // setIsUserModalOpen(false); // Close the modal on success
//       } else {
//         alert("Failed to create user");
//       }
//     } catch (error) {
//       console.error("Error creating user:", error);
//       alert("Error while creating user");
//     }
//     handleUserModalClose();
//   };

//   return (
//     <Modal
//       onClose={() => /* setIsUserModalOpen(false) */ handleUserModalClose()}
//       closeable
//       isOpen={isOpen}
//       animate
//       autoFocus
//       size={SIZE.xxlarge}
//       role={ROLE.dialog}
//     >
//       <ModalHeader>New User</ModalHeader>
//       <ModalBody>
//         <FormControl label={() => "Username"}>
//           <Input
//             value={formValue.username}
//             onChange={(e) =>
//               setFormValue({ ...formValue, username: e.target.value })
//             }
//           />
//         </FormControl>
//         <FormControl label={() => "First Name"}>
//           <Input
//             value={formValue.first_name}
//             onChange={(e) =>
//               setFormValue({ ...formValue, first_name: e.target.value })
//             }
//           />
//         </FormControl>
//         <FormControl label={() => "Last Name"}>
//           <Input
//             value={formValue.last_name}
//             onChange={(e) =>
//               setFormValue({ ...formValue, last_name: e.target.value })
//             }
//           />
//         </FormControl>

//         <FormControl label="Select Locations">
//           <>
//             {locationOptions.map((option) => (
//               <Checkbox
//                 key={option.id}
//                 value={option.id} // Use the id as the value
//                 checked={formValue.locations.includes(option.id)} // Check against IDs
//                 onChange={handleCheckboxChange}
//               >
//                 {option.label}
//               </Checkbox>
//             ))}
//           </>
//         </FormControl>
//         <FormControl label={() => "Role"}>
//           <Select
//             options={roleOptions}
//             value={roleOptions.filter((option) => option.id === formValue.role)}
//             placeholder="Select Role"
//             onChange={(params) =>
//               setFormValue({ ...formValue, role: params.value[0]?.id || "" })
//             }
//           />
//         </FormControl>
//         <FormControl label={() => "Set User Password"}>
//           <Input
//             value={formValue.password}
//             onChange={(e) =>
//               setFormValue({ ...formValue, password: e.target.value })
//             }
//             type="password"
//             placeholder="Enter your password"
//           />
//         </FormControl>
//       </ModalBody>
//       <ModalFooter>
//         <ModalButton
//           onClick={() => /* setIsUserModalOpen(false) */ handleUserModalClose()}
//           kind={ButtonKind.tertiary}
//         >
//           Cancel
//         </ModalButton>
//         <ModalButton onClick={handleSubmitUser}>Submit</ModalButton>
//       </ModalFooter>
//     </Modal>
//   );
// };

export const NewUserModal = ({ isOpen, handleUserModalClose }) => {
  const { locationOptions, roleOptions } = useOptions();

  const initialFormValue = {
    username: "",
    password: "",
    first_name: "",
    last_name: "",
    locations: [],
    role: "",
    status: "active",
  };

  const [formValue, setFormValue] = React.useState(initialFormValue);

  // Reset form function
  const resetForm = () => {
    setFormValue(initialFormValue);
  };

  // Close modal and reset form on outside click or manual close
  const handleClose = () => {
    resetForm();
    handleUserModalClose();
  };

  const handleCheckboxChange = (event) => {
    const { value, checked } = event.target;
    const idValue = parseInt(value, 10); // or use `value` directly if IDs are strings

    setFormValue((prevFormValue) => {
      const updatedLocations = checked
        ? [...prevFormValue.locations, idValue]
        : prevFormValue.locations.filter((loc) => loc !== idValue);

      return { ...prevFormValue, locations: updatedLocations };
    });
  };

  const handleSubmitUser = async () => {
    console.log("formValue (create user form)", formValue);
    try {
      const response = await axios.post(`${apiUrl}/api/user/create`, formValue);
      console.log(response);
      if (response.status === 200) {
        alert("User created successfully");
      } else {
        alert("Failed to create user");
      }
    } catch (error) {
      console.error("Error creating user:", error);
      alert("Error while creating user");
    }
    handleClose();
  };

  return (
    <Modal
      onClose={handleClose}
      closeable
      isOpen={isOpen}
      animate
      autoFocus
      size={SIZE.xxlarge}
      role={ROLE.dialog}
    >
      <ModalHeader>New User</ModalHeader>
      <ModalBody>
        <FormControl label={() => "Username"}>
          <Input
            value={formValue.username}
            onChange={(e) =>
              setFormValue({ ...formValue, username: e.target.value })
            }
          />
        </FormControl>
        <FormControl label={() => "First Name"}>
          <Input
            value={formValue.first_name}
            onChange={(e) =>
              setFormValue({ ...formValue, first_name: e.target.value })
            }
          />
        </FormControl>
        <FormControl label={() => "Last Name"}>
          <Input
            value={formValue.last_name}
            onChange={(e) =>
              setFormValue({ ...formValue, last_name: e.target.value })
            }
          />
        </FormControl>

        <FormControl label="Select Locations">
          <>
            {locationOptions.map((option) => (
              <Checkbox
                key={option.id}
                value={option.id}
                checked={formValue.locations.includes(option.id)}
                onChange={handleCheckboxChange}
              >
                {option.label}
              </Checkbox>
            ))}
          </>
        </FormControl>
        <FormControl label={() => "Role"}>
          <Select
            options={roleOptions}
            value={roleOptions.filter((option) => option.id === formValue.role)}
            placeholder="Select Role"
            onChange={(params) =>
              setFormValue({ ...formValue, role: params.value[0]?.id || "" })
            }
          />
        </FormControl>
        <FormControl label={() => "Set User Password"}>
          <Input
            value={formValue.password}
            onChange={(e) =>
              setFormValue({ ...formValue, password: e.target.value })
            }
            type="password"
            placeholder="Enter your password"
          />
        </FormControl>
      </ModalBody>
      <ModalFooter>
        <ModalButton onClick={handleClose} kind={ButtonKind.tertiary}>
          Cancel
        </ModalButton>
        <ModalButton onClick={handleSubmitUser}>Submit</ModalButton>
      </ModalFooter>
    </Modal>
  );
};

//EDIT USER MODAL COMPONENT (btn inside of user row in StatefulDataTable - with userData prefilling form)
export const EditUserModal = ({
  isOpen,
  handleEditUserModalClose,
  formValue, //passed in from /users (pw  = "")
  setFormValue,
  rowData,
}) => {
  const { locationOptions, roleOptions } = useOptions();
  const [css] = useStyletron();

  const locationMap = React.useMemo(() => ({
    1: "Diberville",
    2: "Douglasville",
    3: "Montgomery",
    4: "Birmingham",
  }), []);

  React.useEffect(() => {
    // Check if formValue.location is a string before processing
    if (typeof formValue.location === "string") {
      const locationIds = formValue.location
        .split(",") // Split by comma
        .map((loc) => loc.trim()) // Trim surrounding whitespace
        .map((loc) =>
          parseInt(
            Object.keys(locationMap).find((id) => locationMap[id] === loc),
            10
          )
        ) // Find matching ID from locationMap and convert to number
        .filter((id) => !isNaN(id)); // Remove any undefined or NaN entries

      // Update formValue.locations to be the array of location IDs
      setFormValue((prevFormValue) => ({
        ...prevFormValue,
        locations: locationIds,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formValue.location, setFormValue]);

  const handleCheckboxChange = (event) => {
    const { value, checked } = event.target;

    // Parse the value as an integer or a string, based on your id type
    const idValue = parseInt(value, 10); // Change to `value` if IDs are strings

    setFormValue((prevFormValue) => {
      const updatedLocations = checked
        ? [...prevFormValue.locations, idValue] // Add ID if checked
        : prevFormValue.locations.filter((loc) => loc !== idValue); // Remove ID if unchecked

      return {
        ...prevFormValue,
        locations: updatedLocations, // Update locations with IDs
      };
    });
  };

  const handleSubmitEdit = async () => {
    try {
      // Find the 'id' corresponding to the selected 'location' label
      // const selectedLocation = locationOptions.find(
      //   (option) => option.label === formValue.location
      // );
      // Find the 'id' corresponding to the selected 'role' label
      const selectedRole = roleOptions.find(
        (option) => option.label === formValue.role
      );

      // Update the formValue with the 'id' values instead of the 'label' strings
      const updatedFormValue = {
        ...formValue,
        location: formValue.location,
        // locations:
        role: selectedRole ? selectedRole.id : formValue.role,
      };

      console.log("updated FormValue", updatedFormValue);

      const response = await axios.post(
        `${apiUrl}/api/user/update`,
        updatedFormValue
      );

      if (response.status === 200) {
        toaster.positive("User updated successfully", {});
        // setIsOpen(false);
        handleEditUserModalClose();
      } else {
        toaster.negative("Failed to update user", {});
      }
    } catch (error) {
      console.error("Error updating user:", error);
      toaster.negative("Error while updating user", {});
    }
  };

  const handleDeactivate = async () => {
    try {
      const selectedLocation = locationOptions.find(
        (option) => option.label === formValue.location
      );
      // Find the 'id' corresponding to the selected 'role' label
      const selectedRole = roleOptions.find(
        (option) => option.label === formValue.role
      );

      // Update the formValue with the 'id' values instead of the 'label' strings
      const updatedFormValue = {
        ...formValue,
        location: selectedLocation ? selectedLocation.id : formValue.location,
        role: selectedRole ? selectedRole.id : formValue.role,
        status: formValue.status === "active" ? "inactive" : "active",
      };

      const response = await axios.post(
        `${apiUrl}/api/user/update`,
        updatedFormValue
      ); //check this api
      console.log("Formvalue", updatedFormValue);
      if (response.status === 200) {
        toaster.positive("User updated successfully", {});
        // setIsOpen(false);
        handleEditUserModalClose();
      } else {
        toaster.negative("Failed to update user", {});
      }
    } catch (error) {
      console.error("Error updating user:", error);
      toaster.negative("Error while updating user", {});
    }
  };

  return (
    <Modal
      onClose={() => /* setIsOpen(false) */ handleEditUserModalClose()}
      closeable
      isOpen={isOpen}
      animate
      autoFocus
      size={SIZE.auto}
      role={ROLE.dialog}
    >
      <ModalHeader>
        Edit User: {rowData.first_name} {rowData.last_name}
      </ModalHeader>
      <ModalBody>
        <FormControl label={() => "User Name"}>
          <Input
            value={formValue.username}
            onChange={(e) =>
              setFormValue({ ...formValue, username: e.target.value })
            }
          />
        </FormControl>
        <FormControl label={() => "First Name"}>
          <Input
            value={formValue.first_name}
            onChange={(e) =>
              setFormValue({ ...formValue, first_name: e.target.value })
            }
          />
        </FormControl>
        <FormControl label={() => "Last Name"}>
          <Input
            value={formValue.last_name}
            onChange={(e) =>
              setFormValue({ ...formValue, last_name: e.target.value })
            }
          />
        </FormControl>

        <FormControl label="Select Locations">
          <>
            {locationOptions.map((option) => (
              <Checkbox
                key={option.id}
                value={option.id} // Use the id as the value
                checked={formValue.locations.includes(option.id)} // Check against IDs
                onChange={handleCheckboxChange}
              >
                {option.label}
              </Checkbox>
            ))}
          </>
        </FormControl>
        <FormControl label={() => "Role"}>
          <Select
            options={roleOptions}
            value={roleOptions.filter((option) => option.id === formValue.role)}
            placeholder={formValue.role ? formValue.role : "Select Role"}
            onChange={(params) =>
              setFormValue({
                ...formValue,
                role: params.value[0]?.id || "",
              })
            }
          />
        </FormControl>
        <FormControl label={() => "Change User's Password (optional)"}>
          <Input
            value={formValue.password}
            onChange={(e) =>
              setFormValue({ ...formValue, password: e.target.value })
            }
            type="password"
          />
        </FormControl>
      </ModalBody>
      <ModalFooter>
        <ModalButton
          onClick={() => /* setIsOpen(false) */ handleEditUserModalClose()}
          kind={ButtonKind.tertiary}
        >
          Cancel
        </ModalButton>
        <ModalButton onClick={handleSubmitEdit}>Update User</ModalButton>
        {formValue.status === "inactive" ? (
          <ModalButton
            onClick={handleDeactivate}
            className={css({ backgroundColor: "green" })}
          >
            Activate User
          </ModalButton>
        ) : (
          <ModalButton
            onClick={handleDeactivate}
            className={css({ backgroundColor: "red" })}
          >
            Deactivate User
          </ModalButton>
        )}
      </ModalFooter>
    </Modal>
  );
};
// export const EditUserModal = ({
//   isOpen,
//   handleEditUserModalClose,
//   formValue,
//   setFormValue,
//   rowData,
// }) => {
//   const { locationOptions, roleOptions } = useOptions();
//   const [css] = useStyletron();

//   // Reuse the checkbox change handler for locations
//   const handleCheckboxChange = (event) => {
//     const { value, checked } = event.target;
//     const idValue = parseInt(value, 10); // Adjust based on your ID type

//     setFormValue((prevFormValue) => {
//       const updatedLocations = checked
//         ? [...prevFormValue.locations, idValue] // Add if checked
//         : prevFormValue.locations.filter((loc) => loc !== idValue); // Remove if unchecked

//       return {
//         ...prevFormValue,
//         locations: updatedLocations, // Update with IDs
//       };
//     });
//   };

//   console.log("formValue");

//   const handleSubmitEdit = async () => {
//     try {
//       const selectedRole = roleOptions.find(
//         (option) => option.label === formValue.role
//       );

//       const updatedFormValue = {
//         ...formValue,
//         role: selectedRole ? selectedRole.id : formValue.role,
//       };

//       const response = await axios.post(
//         `${apiUrl}/api/user/update`,
//         updatedFormValue
//       );

//       if (response.status === 200) {
//         toaster.positive("User updated successfully", {});
//         handleEditUserModalClose();
//       } else {
//         toaster.negative("Failed to update user", {});
//       }
//     } catch (error) {
//       console.error("Error updating user:", error);
//       toaster.negative("Error while updating user", {});
//     }
//   };

//   const handleDeactivate = async () => {
//     try {
//       const selectedRole = roleOptions.find(
//         (option) => option.label === formValue.role
//       );

//       const updatedFormValue = {
//         ...formValue,
//         role: selectedRole ? selectedRole.id : formValue.role,
//         status: formValue.status === "active" ? "inactive" : "active",
//       };

//       const response = await axios.post(
//         `${apiUrl}/api/user/update`,
//         updatedFormValue
//       );

//       if (response.status === 200) {
//         toaster.positive("User updated successfully", {});
//         handleEditUserModalClose();
//       } else {
//         toaster.negative("Failed to update user", {});
//       }
//     } catch (error) {
//       console.error("Error updating user:", error);
//       toaster.negative("Error while updating user", {});
//     }
//   };

//   return (
//     <Modal
//       onClose={() => handleEditUserModalClose()}
//       closeable
//       isOpen={isOpen}
//       animate
//       autoFocus
//       size={SIZE.auto}
//       role={ROLE.dialog}
//     >
//       <ModalHeader>
//         Edit User: {rowData.first_name} {rowData.last_name}
//       </ModalHeader>
//       <ModalBody>
//         <FormControl label={() => "User Name"}>
//           <Input
//             value={formValue.username}
//             onChange={(e) =>
//               setFormValue({ ...formValue, username: e.target.value })
//             }
//           />
//         </FormControl>
//         <FormControl label={() => "First Name"}>
//           <Input
//             value={formValue.first_name}
//             onChange={(e) =>
//               setFormValue({ ...formValue, first_name: e.target.value })
//             }
//           />
//         </FormControl>
//         <FormControl label={() => "Last Name"}>
//           <Input
//             value={formValue.last_name}
//             onChange={(e) =>
//               setFormValue({ ...formValue, last_name: e.target.value })
//             }
//           />
//         </FormControl>
//         <FormControl label="Select Locations">
//           <>
//             {locationOptions.map((option) => (
//               <Checkbox
//                 key={option.id}
//                 value={option.id}
//                 checked={formValue.locations.includes(option.id)}
//                 onChange={handleCheckboxChange}
//               >
//                 {option.label}
//               </Checkbox>
//             ))}
//           </>
//         </FormControl>
//         <FormControl label={() => "Role"}>
//           <Select
//             options={roleOptions}
//             value={roleOptions.filter((option) => option.id === formValue.role)}
//             placeholder={formValue.role ? formValue.role : "Select Role"}
//             onChange={(params) =>
//               setFormValue({
//                 ...formValue,
//                 role: params.value[0]?.id || "",
//               })
//             }
//           />
//         </FormControl>
//         <FormControl label={() => "Change User's Password (optional)"}>
//           <Input
//             value={formValue.password}
//             onChange={(e) =>
//               setFormValue({ ...formValue, password: e.target.value })
//             }
//             type="password"
//           />
//         </FormControl>
//       </ModalBody>
//       <ModalFooter>
//         <ModalButton
//           onClick={() => handleEditUserModalClose()}
//           kind={ButtonKind.tertiary}
//         >
//           Cancel
//         </ModalButton>
//         <ModalButton onClick={handleSubmitEdit}>Update User</ModalButton>
//         {formValue.status === "inactive" ? (
//           <ModalButton
//             onClick={handleDeactivate}
//             className={css({ backgroundColor: "green" })}
//           >
//             Activate User
//           </ModalButton>
//         ) : (
//           <ModalButton
//             onClick={handleDeactivate}
//             className={css({ backgroundColor: "red" })}
//           >
//             Deactivate User
//           </ModalButton>
//         )}
//       </ModalFooter>
//     </Modal>
//   );
// };
